import { createApp, watchEffect } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from '@/i18n/i18n-setup.js'
import vuetify from '@/plugins/vuetify.js'

import App from './App.vue'
import router from './router'
import dayjs from '@/plugins/dayjs'
import hlBtn from '@/components/hl/hlBtn.vue'
import hlSnackbar from '@/components/hl/hlSnackbar.vue'

import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

import { Buffer } from 'node:buffer'

// import '@/registerServiceWorker.js'

// @ts-ignore
window.Buffer = Buffer

//https://vite-pwa-org.netlify.app/guide/prompt-for-update.html
// import { registerSW } from 'virtual:pwa-register'

// import vue3GoogleLogin from 'vue3-google-login'

import './assets/main.css'
// import './assets/main.scss'
import '@mdi/font/css/materialdesignicons.css'

// import { registerSW } from 'virtual:pwa-register'

const toastOptions = {
  autoClose: 4500,
  limit: 5
}

// Global error handler to catch any suppressed errors
window.addEventListener('error', (event) => {
  console.error('🚨 GLOBAL ERROR CAUGHT:', event.error)
  console.error('Error message:', event.message)
  console.error('Error filename:', event.filename)
  console.error('Error line:', event.lineno)
  console.error('Error column:', event.colno)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 UNHANDLED PROMISE REJECTION:', event.reason)
})

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.config.globalProperties.$date = dayjs
app.component('HlBtn', hlBtn)
app.component('HlSnackbar', hlSnackbar)

console.log('***** PROD ENVIRONMENT ***** (%s)', import.meta.env.PROD)

// app.use(updateSW)
app.use(pinia)
app.use(router)
app.use(i18n)

watchEffect(() => {
  const locale =
    typeof i18n.global.locale === 'string'
      ? i18n.global.locale
      : i18n.global.locale.value
  document.documentElement.lang = locale || 'nb'
})
app.use(vuetify)
app.use(Vue3Toastify, toastOptions)

app.mount('#app')
